import React from "react";


function Footer() {
    return (
        <div className="w-full bg_img h-104 bg-cover bg-no-repeat pt-36">
            <div className="w-10/12 m-auto flex justify-between flex-row">
                <div className="w-5/12 pr-16">
                    <p className="text-md">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Provident, culpa ex sequi voluptatem sed vel necessitatibus harum
                        praesentium autem quaerat magni quas, vitae itaque molestiae quae
                        quo earum modi quam.
                    </p>
                    <p className="flex flex-row mt-2">
                        <a href="index">
                            <img
                                src={require("../assets/index/facebook.png")}
                                alt=""
                                className="h-6 mr-5"
                            />
                        </a>
                        <a href="index">
                            <img
                                src={require("../assets/index/instagram.png")}
                                alt=""
                                className="h-6"
                            />
                        </a>
                    </p>
                </div>
                <div className="w-2/12">
                    <p className="text-lg font-gilroy tracking-wide">Company</p>
                    <ul className="list-none">
                        <li className="mt-1">
                            <a href=""> For Consultants </a>{" "}
                        </li>
                        <li className="mt-1">
                            <a href=""> Find a consultant </a>{" "}
                        </li>
                        <li className="mt-1">
                            <a href=""> Our Story </a>{" "}
                        </li>
                        <li className="mt-1">
                            <a href=""> Get matched </a>{" "}
                        </li>
                        <li className="mt-1">
                            <a href=""> FAQ </a>{" "}
                        </li>
                        <li className="mt-1">
                            <a href=""> Contact </a>{" "}
                        </li>
                        <li className="mt-1">
                            <a href=""> Visit Blog </a>{" "}
                        </li>
                    </ul>
                </div>
                <div className="w-2/12">
                    <p className="text-lg font-gilroy tracking-wide">Legal</p>
                    <ul className="list-none">
                        <li className="mt-1">
                            <a href=""> Imprint </a>{" "}
                        </li>
                        <li className="mt-1">
                            <a href=""> Cookies </a>{" "}
                        </li>
                        <li className="mt-1">
                            <a href=""> Security </a>{" "}
                        </li>
                        <li className="mt-1">
                            <a href=""> Privacy Policy </a>{" "}
                        </li>
                        <li className="mt-1">
                            <a href=""> Terms of use</a>{" "}
                        </li>
                        <li className="mt-1">
                            <a href=""> Cookie Settings </a>{" "}
                        </li>
                    </ul>
                </div>
                <div className="w-3/12">
                    <p className="text-lg font-gilroy tracking-wide">
                        Are you a consultant?
                    </p>
                    <ul className="list-none">
                        <li className="mt-1">
                            <a href=""> For Consultants </a>{" "}
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    );
}


export default Footer;
